<script lang="ts">
  import { DECK, type NodeId } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { session } from "../net/session.svelte.js";
  import { ORIENTATION } from "@spacecrew/shared";
  import BridgeConsole from "../stations/BridgeConsole.svelte";
  import ReactorConsole from "../stations/ReactorConsole.svelte";
  import BreakerPanel from "../stations/BreakerPanel.svelte";
  import StoragePanel from "../stations/StoragePanel.svelte";

  const snap = $derived(ship.snap!);
  const me = $derived(snap.crew[session.sessionId]);
</script>

<section aria-labelledby="station-title">
  <h2 id="station-title">STATION</h2>
  {#if !me}
    <p class="dim">NO STATION ASSIGNED.</p>
  {:else if me.toNodeId}
    <p class="dim">IN TRANSIT → {DECK.nodes[me.toNodeId as NodeId].label}. NO CONTROLS AVAILABLE IN CORRIDORS.</p>
  {:else if snap.phase === "lobby"}
    <div class="orientation">
      {#each ORIENTATION as line, i}<p class={i === 0 ? "" : "dim"}>{line}</p>{/each}
    </div>
  {:else if me.nodeId === "bridge"}
    <BridgeConsole />
  {:else if me.nodeId === "reactor"}
    <ReactorConsole />
  {:else if me.nodeId === "breaker_bay"}
    <BreakerPanel />
  {:else if me.nodeId === "storage"}
    <StoragePanel />
  {/if}
</section>

<style>
  .orientation { display: grid; gap: 0.35rem; border: 1px solid var(--fg-dim); padding: 0.7rem; max-width: 70ch; }
  .orientation p { margin: 0; }
</style>